// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { NetworkSource } from "@lib/messaging/NetworkSource";
import { RawMessage } from "@lib/messaging/RawMessage";
import { TypeUtility } from "@lib/utilities/TypeUtility";

type RawMessageDto = {
  destination: string;
  source: string;
  messageFormat: string;
  messageObject: object;
};

export class RawMessageSerializer
{
  deserialize(message: object): Nullable<RawMessage>
  {
    const rawMessage = message as Partial<RawMessageDto>;
    if (TypeUtility.isString(rawMessage.destination) && NetworkSource.isValidNetworkSource(rawMessage.destination)
      && TypeUtility.isString(rawMessage.source) && NetworkSource.isValidNetworkSource(rawMessage.source)
      && TypeUtility.isString(rawMessage.messageFormat)
      && TypeUtility.isObject(rawMessage.messageObject))
    {
      return {
        destination: NetworkSource.parse(rawMessage.destination),
        source: NetworkSource.parse(rawMessage.source),
        messageFormat: rawMessage.messageFormat,
        messageObject: rawMessage.messageObject
      };
    }
    return null;
  }

  serialize(rawMessage: RawMessage): object
  {
    const message: RawMessageDto = {
      destination: rawMessage.destination.toString(),
      messageFormat: rawMessage.messageFormat,
      messageObject: rawMessage.messageObject,
      source: rawMessage.source.toString()
    };
    return message;
  }
}